import { Button } from '@/components/ui/elements/button';
import { Input } from '@/components/ui/elements/input';
import { Heading3 } from '@/components/ui/typography/Typography';
import { ModelID } from '@/types';
import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

export const LeadLookup = () => {
  const navigate = useNavigate();
  const [id, setID] = useState<ModelID>();

  const goToLead = () => {
    if (!id) return;
    navigate({ to: `/leads/lead/${id}/quote` });
  };

  return (
    <div className="rounded border px-4 pt-2 pb-4 bg-background">
      <Heading3>Go To Quote</Heading3>
      <div className="flex space-x-1">
        <Input
          type="number"
          name="lead_id"
          placeholder="Quote #..."
          defaultValue={id}
          onChange={(event) => setID(event.target.value)}
        />
        <Button onClick={goToLead} size="lg" disabled={!id} id="load-quote-submit">
          Go
        </Button>
      </div>
    </div>
  );
};
